import { Form } from 'antd';

import Questionnaire from '@shared/components/Questionnaire/Questionnaire';
import type { QuestionnaireItem } from '@shared/services/appointment/questionnaire/types/getQuestionnaire.type';

interface Props {
  additionalQuestionKey?: number;
  multipleQuestions: QuestionnaireItem[];
}

const QuestionnaireGroup = ({ additionalQuestionKey, multipleQuestions }: Props) => (
  <Form.Item noStyle>
    {multipleQuestions?.map((questionItem) => (
      <Questionnaire
        key={additionalQuestionKey ? `${questionItem.LinkId}_${additionalQuestionKey}` : questionItem.LinkId}
        questionItem={
          {
            ...questionItem,
            AdditionalQuestionKey: additionalQuestionKey,
            LinkId: additionalQuestionKey ? `${questionItem.LinkId}_${additionalQuestionKey}` : questionItem.LinkId,
          } as QuestionnaireItem
        }
      />
    ))}
  </Form.Item>
);

export default QuestionnaireGroup;
